import { useFormikContext } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import type { ReactElement } from 'react'
import type { IAppSummary } from '~/types/application'
import type { MobileDeviceType } from '~/types/device-type'
import type { NavGraphFormValues } from '~/types/navigation-graph'

import AppSelectorModal from '../modals/AppSelectorModal'

import { AppSelectorDropdown } from '~/components/AppSelector'
import BackNavigation from '~/components/BackNavigation'
import ResetWarningModal from '~/components/ResetWarningModal'

import './styles.scss'

interface Props {
  navigationGraphId?: string
  selectedApp: IAppSummary[]
}

const NavGraphDetailsHeader = ({ navigationGraphId, selectedApp }: Props): ReactElement => {
  const navigate = useNavigate()

  const { initialValues, resetForm, setFieldValue } = useFormikContext<NavGraphFormValues>()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [resetModalOpen, setResetModalOpen] = useState(false)

  const handleModalOpen = () => {
    selectedApp ? setResetModalOpen(true) : setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
    navigate('/dynamic-screens/navigation-graphs')
  }

  const handleRowClick = ({ app_key, device_type }: { app_key: string; device_type: MobileDeviceType }) => {
    resetForm({
      values: {
        navigationTargetToPageContainer: [],
        status: initialValues.status,
        tags: initialValues.tags,
        title: initialValues.title,
      },
    })

    setFieldValue('appKey', app_key)
    setFieldValue('deviceType', device_type)
    setIsModalOpen(false)
  }

  const handleResetModalClose = () => setResetModalOpen(false)

  const handleResetModalConfirm = () => {
    setResetModalOpen(false)
    setIsModalOpen(true)
  }

  useEffect(() => {
    navigationGraphId === 'creation' && setIsModalOpen(true)
  }, [navigationGraphId])

  const appSelectorApp = selectedApp.map((app) => ({
    app_key: app.app_key,
    default_display_name: app.name,
    device_type: app.device_type,
    icon_file_id: app.app_icon_url.replace('https://fastly.mwm-storage.mwmcdn.com/raw_files/', ''),
  }))

  return (
    <div className="nav-graph-details-header">
      <div className="header-details">
        <BackNavigation backgroundColor="dark" title="Back" to="/dynamic-screens/navigation-graphs" />
        <AppSelectorDropdown apps={appSelectorApp} displayAppLogo onClick={handleModalOpen} />
        <div className="empty-div-placeholder" />
        <AppSelectorModal
          isOpen={isModalOpen}
          onAppSelectorRowClicked={handleRowClick}
          onClose={handleModalClose}
          selectedApp={{ id: selectedApp[0]?.app_id, name: selectedApp[0]?.name }}
          title="Choose the navigation graph app"
        />
        <ResetWarningModal
          isOpen={resetModalOpen}
          mainText="Change application"
          onClose={handleResetModalClose}
          onConfirm={handleResetModalConfirm}
          subText="Changing the application will reset all page containers in the navigation graph."
        />
      </div>
    </div>
  )
}

export default NavGraphDetailsHeader
